import { bool, func, shape } from 'prop-types';
import React, { useState } from 'react';

import IconArrowDown, { COLOUR } from '../assets/IconArrowDown/IconArrowDown';
import IconArrowUp from '../assets/IconArrowUp/IconArrowUp';

import styles from './ShowMore.module.scss';

export default function ShowMore({ size, isActive, onClick, showText, hideText }) {
  const [isfocused, setIsfocused] = useState(false);

  const title = isActive ? hideText : showText;

  const onFocus = () => setIsfocused(true);
  const onFocusLost = () => setIsfocused(false);

  return (
    <button
      onClick={onClick}
      onMouseEnter={onFocus}
      onMouseLeave={onFocusLost}
      className={styles.button}
      type='button'
    >
      <span className={styles.button__name}>{title}</span>
      {isActive ? (
        <div style={{ width: size?.w, height: size?.h }}>

          <IconArrowUp color={isfocused ? COLOUR.PINK : COLOUR.DARK_PINK} />
        </div>
      ) : (
        <div style={{ width: size.w, height: size.h }}>
          <IconArrowDown color={isfocused ? COLOUR.PINK : COLOUR.DARK_PINK} />
        </div>

      )}
    </button>
  );
}

ShowMore.propTypes = {
  isActive: bool,
  onClick: func,
  size: shape({}),
};

ShowMore.defaultProps = {
  isActive: false,
  onClick: () => {},
  size: { w: 15, h: 8 },
  showText: 'show more',
  hideText: 'show less',

};
